import {
  Flex,
  Text,
  LiveViewDisabledIcon,
} from '@amzn/ring-ui-react-components';
import { useIsMobile } from 'src/shared/hooks';

export const NoEventsFound = () => {
  const isMobile = useIsMobile();
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      mt={isMobile ? 140 : 0}
      mb={isMobile ? 140 : 0}
      data-testid="no-event-found"
    >
      <LiveViewDisabledIcon boxSize={9} mb="13px" color="neutral.200" />

      <Text fontSize="lg" align="center" mb="16px" fontWeight="semibold">
        No events found
      </Text>
      <Text fontSize="xs" align="center">
        This device doesn't have any events yet
      </Text>
    </Flex>
  );
};

export default NoEventsFound;
